<template>
    <div class="container"  ref="container">
        <div class="pageContent">
            <main>
                <div :class="{'full-width white-bg': $mqBelow('DESKTOP')}">
                    <ActionCard :data="request?.company"
                                :action-name="requestType"
                                :action="handlerCreateApplication"
                                :fixed-layout="false"
                                v-if="$mqBelow('DESKTOP')"
                    >
                        <template #footer>
                            <div class="flex between p-20">
                                <ABadge v-if="request?.deadline">{{ messages?.deadline }} {{ request?.deadline }}</ABadge>
                                <div class="task-card__rating flex v-center">
                                    <svg class="icon" width="14" height="14" viewBox="0 0 14 14"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M13.9635 5.06994C13.8719 4.78645 13.6204 4.58511 13.3229 4.5583L9.28216 4.19139L7.68432 0.451504C7.56651 0.177419 7.29819 0 7.00007 0C6.70195 0 6.43364 0.177419 6.31582 0.452145L4.71798 4.19139L0.67656 4.5583C0.379616 4.58575 0.128816 4.78645 0.0366355 5.06994C-0.0555452 5.35342 0.0295858 5.66436 0.254216 5.86036L3.30857 8.53905L2.40791 12.5065C2.34201 12.7982 2.45523 13.0997 2.69727 13.2747C2.82737 13.3687 2.97958 13.4165 3.13307 13.4165C3.26542 13.4165 3.39669 13.3808 3.51451 13.3103L7.00007 11.2271L10.4844 13.3103C10.7393 13.4637 11.0607 13.4497 11.3022 13.2747C11.5444 13.0992 11.6575 12.7975 11.5916 12.5065L10.6909 8.53905L13.7453 5.8609C13.9699 5.66436 14.0557 5.35396 13.9635 5.06994Z"></path>
                                    </svg>
                                    <span>{{ request?.rating_min + '/' + request?.rating_max }}</span>
                                </div>
                            </div>
                        </template>
                    </ActionCard>
<!--                    <div class="full-width white-bg pos-a">-->
<!--                        <div class="container tabsContainer">-->
<!--                            <ATabs :tabs="result.tabs"-->
<!--                                   v-model="activeTab"-->
<!--                            >-->
<!--                            </ATabs>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
                <div class="content">
                    <template v-if="1">
                        <section id="mobile" class="mobileStructure" v-if="$mqBelow('DESKTOP')">
                            <div class="page-header__tags gap-10" v-if="subHeader.tags">
                                <a-badge v-for="(tag, i) in subHeader.tags" :key="i" :params="tag">{{ tag.name }}</a-badge>
                            </div>
                            <Breadcrumbs class="mb-3" :items="subHeader.breadcrumbs"/>
                            <h3>{{ request?.name }}</h3>
                        </section>

                      <section class="about mb-3" v-if="request?.previewText">
                        <h3>{{messages?.aboutTitle}}</h3>
                        <section v-html="request?.previewText"/>
                      </section>

                        <section class="materials mb-4">
                            <h3>{{ messages?.materials }}</h3>

<!--                            :params="{translates: {actionTextAdd: messages?.download}, canUpload: true}"-->
                            <UserFiles :items="request?.files"
                            >
                                <template #actions="{index}">
<!--                                    @click.prevent="doDownloadFile($event, index)"-->
                                    <a class="user-files__remove-btn" :href="this.request?.files[index].SRC" target="_blank">{{ messages?.download }}</a>
                                </template>
                            </UserFiles>
                        </section>

                        <!--                <ReviewsListSection :list-data="request?.reviews" title="Отклики" :count="12"/>-->
                        <div class="flex v-center reviews__titleWrapper" v-if="request?.reviews">
                          <h3  v-if="request?.status!='closed'" class="reviews__title">{{ messages?.reviews }}</h3>
                          <h3  v-else class="reviews__title">{{ messages?.inWorkAt }}</h3>
                          <AChip class="flex v-center ml-3"  v-if="request?.status!='closed'">{{ request?.reviews.length }}</AChip>
                        </div>
                        <div :class="['reviews-card']" class="mb-2" v-for="review in request?.reviews">

                            <div class="reviews-card__inner">
                                <ReviewsSmallCard
                                    :position="review.position"
                                    :photo="review.photo"
                                    :author="review.author"
                                    :company="review.company"
                                    :date="review.date"
                                    :text="review.text"
                                >
                                    <template #footer :review="review">
                                        <div class="flex between">
                                            <div class="rating" v-if="review.rating">
                                                {{ review.rating }} / 10
                                            </div>
                                            <a
                                                href="javascript:void(0);"
                                                v-if="request?.status!='closed'&&review?.confirmBtn"
                                                @click.prevent="makeOffer(review)"
                                                class="makeOffer"
                                            >
                                                  {{ messages?.proposeOffer }}
                                            </a>
                                          <span v-if="review.confirmText">{{review.confirmText}}</span>
                                            <div class="accomplished" v-if="review.accomplished">
                                                <b>{{ review.accomplished }}</b> {{ messages?.projectsDone }}
                                            </div>
                                        </div>
                                    </template>
                                </ReviewsSmallCard>
                            </div>
                        </div>
                    </template>

                </div>


            </main>
            <aside>
                <ActionCard :data="request?.company"
                            :action-name="requestType"
                            :action-status="request?.user?.sendedRequest?'disabled':''"
                            :action="handlerCreateApplication"
                            :fixed-layout="false"
                            v-if="$mqAbove('TABLET')"
                >
                    <template #footer>
                        <div class="flex between p-20">
                            <ABadge v-if="request?.deadline">{{ messages?.deadline }} {{ request?.deadline }}</ABadge>
                            <div class="task-card__rating flex v-center">
                                <svg class="icon" width="14" height="14" viewBox="0 0 14 14"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M13.9635 5.06994C13.8719 4.78645 13.6204 4.58511 13.3229 4.5583L9.28216 4.19139L7.68432 0.451504C7.56651 0.177419 7.29819 0 7.00007 0C6.70195 0 6.43364 0.177419 6.31582 0.452145L4.71798 4.19139L0.67656 4.5583C0.379616 4.58575 0.128816 4.78645 0.0366355 5.06994C-0.0555452 5.35342 0.0295858 5.66436 0.254216 5.86036L3.30857 8.53905L2.40791 12.5065C2.34201 12.7982 2.45523 13.0997 2.69727 13.2747C2.82737 13.3687 2.97958 13.4165 3.13307 13.4165C3.26542 13.4165 3.39669 13.3808 3.51451 13.3103L7.00007 11.2271L10.4844 13.3103C10.7393 13.4637 11.0607 13.4497 11.3022 13.2747C11.5444 13.0992 11.6575 12.7975 11.5916 12.5065L10.6909 8.53905L13.7453 5.8609C13.9699 5.66436 14.0557 5.35396 13.9635 5.06994Z"></path>
                                </svg>
                                <span>{{ request?.rating_min + '/' + request?.rating_max }}</span></div>
                        </div>
                    </template>
                </ActionCard>
            </aside>
        </div>
      
    </div>
</template>

<script>
import {ref, computed, onMounted} from 'vue'
import {useHeader} from "~/composables/useHeader";
import {AChip, ABtn, ABadge, ATab, useAModal, useAProgressBar} from '~/components/ui'
import ReviewsListSection from "~/components/sections/ReviewsListSection";
import ActionCard from "~/components/cards/ActionCard";
import ATabs from "~/components/ui/ATabs";
import ProjectListSection from "~/components/sections/ProjectListSection";
import Breadcrumbs from "~/components/main/Breadcrumbs";
import UserFiles from "~/components/cards/UserFiles";
import ReviewsSmallCard from "~/components/cards/ReviewsSmallCard";
import { send } from '~/services/api';
import {useStore} from "vuex";

export default {
    name: "RequestPageContainer",
    props: ['result'],
    components: {
        ReviewsSmallCard,
        UserFiles,
        Breadcrumbs,
        ProjectListSection,
        ATabs,
        ActionCard,
        ReviewsListSection,
        AChip,
        ABtn,
        ABadge,
        ATab
    },
    setup(prop) {
      const {subHeader} = useHeader();
      const progress = useAProgressBar();
      const activeTab = ref(0);
      const container = ref(null);
      const modal = useAModal();


      const handlerCreateApplication = () => {
          if (prop.result.request?.user?.isNpo) {
            location.href=prop.result.request?.user?.createLink;
          } else if(prop.result.request?.user?.isAuthorized) {
            if(!prop.result.request?.user?.sendedRequest) {
              modal.show('respond-application','');
            }
          } else {
            showNotification(
                'nativeInfo',
                prop.result?.messages?.respondForProject,
                prop.result?.messages?.respondForProjectRegisterText,
                {
                  actions:[
                    {
                      bg:'#00A59E',
                      color:'',
                      title:prop.result?.messages?.respondForProjectRegisterBtn,
                      action:false,
                      paternAction:'registration'
                    }
                  ]
                }
            );
          }
      }

      const downloadFile = (event, index) => {
          console.log({event, index})
      }

      const makeOffer = async rew => {
        progress.show();

        await send(rew.action.link, {method: "POST"}, rew.action.data).then((response) => {
          if(response.success) {
            showNotification('success','',prop.result.messages.confirmResponseText);

          } else {
            showNotification('danger','',response.error);
          }
          progress.hide();
        })
      }
      onMounted(() => {
        setTimeout(() => {
          window.replaceHLink(container.value);
        }, 800);
      });
      return {
        subHeader,
        activeTab,
        container,
        makeOffer,
        downloadFile,
        handlerCreateApplication
      }
    },
    methods : {
        async doDownloadFile(event, index) {
            try {
                const file = this?.request?.files[index];
                const response = await axios.get('/download.php', {
                    params: file
                } );
            } catch (err) {
                console.error(err);
            }
        }

    },
    computed : {
        request() {
            return this?.result?.request;
        },
        user() {
            return this?.result?.request?.user;
        },
        requestType() {
            /**
             * @todo to code action mechanic after receiving technical task
             */
            if (this?.user?.isAuthorized) {
                if (this?.user?.isNpo) {
                    return this?.messages?.createRequest;
                } else {
                    return this?.messages?.respondForProject
                }
            } else {
              return this?.messages?.respondForProject
            }
        },
        messages() {
            return this?.result?.messages;
        },
    }
}
</script>

<style scoped lang="scss">
.page-header__tags {
  margin-bottom: 1rem;
}
.mobileStructure {
  padding-top: 1rem;
}
::v-deep .ActionCard {
    position: sticky;
    top: calc(rem(150) + rem(100));
    transform: translateY(rem(-270));

    &__footer {
        @include tablet {
            flex-grow: 1;
        }
    }

    @include tablet {
        position: relative;
        top: 0;
        transform: unset;
        box-shadow: unset;
    }
}

.tabsContainer {
    @extend %contentLayout;
}

.content{
    padding-top: rem(125);

    @include tablet {
        padding-top: 0;
    }
}

.about {

}

.makeOffer {
    margin-left: auto;
    margin-right: rem(20);
}

.rating {
    color: var(--c-secondary-200);
    font-weight: 600;
    font-size: rem(14);
    line-height: rem(19);
    padding-left: rem(20);
    background-size: rem(16);
    background: url("/local/templates/main/img/icons/smile.svg") no-repeat left center;
}

.accomplished {
    font-size: rem(14);
    line-height: rem(19);
    color: var(--c-gray-500);
}

::v-deep .ActionCard__footer {
    padding: 20px;
}
</style>